import { getTemporalSeparators } from "../../../../util/date-time-util.js";
import { isq } from "../../../../isq/index.js";
export const extractPropertyMap = (observationTypeDefinition, sensorProbeMap) => {
    let tableViewDefinition = (observationTypeDefinition.views.table);
    const propertiesMap = processTableView(tableViewDefinition);
    // are we supposed to have sensor data?
    if (sensorProbeMap) {
        const numToPrecision = (num, precision) => {
            return num ? Number(num).toFixed(precision) : '';
        };
        // apply probe precision
        const sensorValueToFixedOrEmptyString = (item, probe) => {
            if (item.sensorData && item.sensorData[probe.id] != undefined) {
                return numToPrecision(item.sensorData[probe.id], probe.precision);
            }
            return '';
        };
        const sensorFeedProperties = Object.values(sensorProbeMap).map(probe => {
            return {
                column: {
                    key: `sensorData.${probe.id}`,
                    defaultContent: '-',
                    title: `${probe.description} (${isq.getUnit(probe.unit).getSymbol()})`,
                    export: true,
                    visible: true
                },
                display: v => sensorValueToFixedOrEmptyString(v, probe),
                value: v => v, // ??
                export: v => sensorValueToFixedOrEmptyString(v, probe),
                type: 'number'
            };
        });
        // // only add to the table itself, don't bother making these searchable
        // const sensorFeedProperties = observationTypeDefinition.features.feedProbes.map(probe => {
        //     const key = `sensorData.${probe.id}`;
        //     return {
        //         column: {
        //             key,
        //             defaultContent: '-',
        //             title: probe.description,
        //         } as ColumnDefinition,
        //         display: v => sensorValueToFixedOrEmptyString(v, probe),
        //         value: v => v, // ??
        //         export: v => sensorValueToFixedOrEmptyString(v as ObservationDatum, probe),
        //         type: 'number'
        //     } as DatumPropertyDefinition;
        // });
        sensorFeedProperties.forEach(sensorFeedProperty => {
            propertiesMap[sensorFeedProperty.column.key] = sensorFeedProperty;
        });
    } // end-if inject sensor feed data
    return propertiesMap;
};
const processTableView = (tableViewDefinition) => {
    let columns = tableViewDefinition.columns.map((column) => {
        //convert old style definitions to new style definitions
        // fix missing parameters
        let columnDefinition = {
            key: column.key,
            field: column.key,
            title: column.title,
            schemaType: column.schemaType,
            probeType: column.probeType,
            probeOptions: {
                table: {
                    valueToDependentKeyMap: column.probeOptions && column.probeOptions.table
                        ? column.probeOptions.table.valueToDependentKeyMap
                        : column.renderOptions && column.renderOptions.depMap
                            ? column.renderOptions.depMap
                            : undefined,
                    render: column.probeOptions && column.probeOptions.table
                        ? column.probeOptions.table.render
                        : column.renderType && column.renderType === 'mapDependent'
                            ? 'mapDependent'
                            : 'auto',
                    sortOnLabel: column.enumLabels
                        ? true
                        : column.probeOptions
                            ? column.probeOptions.table
                                ? column.probeOptions.table.sortOnLabel
                                : !(column.probeOptions.sortOnLabel === false)
                            : column.renderOptions
                                ? !(column.renderOptions.sortOnValue === true)
                                : true
                },
                dateFormat: column.probeOptions && column.probeOptions.dateFormat
                    ? column.probeOptions.dateFormat
                    : column.datetimeFormat
                        ? column.datetimeFormat
                        : column.probeType.toLowerCase().startsWith('datetime')
                            ? 'L LT'
                            : undefined
            },
            enumLabels: column.enumLabels,
            dependentColumn: column.dependentColumn != null
                ? column.dependentColumn.substring
                    ? true
                    : column.dependentColumn
                : false,
            visible: !(column.visible === false),
            defaultContent: column.defaultContent ? column.defaultContent : '&mdash;',
            export: column.probeOptions && column.probeOptions.table
                ? !(column.probeOptions.table['export'] === false)
                : true,
            exportDateFormat: column.probeOptions && column.probeOptions.table
                ? column.probeOptions.table.exportDateFormat
                : undefined,
            position: column.position
        };
        columnDefinition.key +=
            columnDefinition?.probeOptions?.table?.render === 'mapDependent' ? '-dependent' : '';
        return columnDefinition;
    });
    let independentColumns = columns.filter((column) => !column.dependentColumn);
    let dependentColumnMap = columns
        .filter((column) => column.dependentColumn)
        .reduce((colMap, col) => {
        colMap[col.field] = col;
        return colMap;
    }, {});
    let propertyMap = independentColumns
        .map((column) => createDatumPropertyDefinition(column, dependentColumnMap))
        .reduce((propertyMap, propertyDef) => {
        propertyMap[propertyDef.column.key] = propertyDef;
        return propertyMap;
    }, {});
    return propertyMap;
};
//comes from legacy data-source/table.ts
export const createDatumPropertyDefinition = (column, columnMap, referencedColumns) => {
    let columnType = getColumnType(column);
    let valueGetter;
    let valueFormatter;
    let valueExporter;
    if (columnType === 'dependent') {
        var columnMappers = {};
        if (column.probeOptions?.table?.valueToDependentKeyMap) {
            Object.entries(column.probeOptions?.table?.valueToDependentKeyMap).forEach((entry) => {
                referencedColumns = referencedColumns ? referencedColumns : [];
                if (!referencedColumns.includes(entry[1])) {
                    columnMappers[entry[0]] = createDatumPropertyDefinition(columnMap[entry[1]], columnMap, referencedColumns.concat([column.field]));
                }
            });
            // add the mappers to the options
            column.probeOptions.table.mappers = columnMappers;
        }
        valueGetter = valueGetFactories['dependent'](column);
        valueFormatter = valueDisplayFactories['dependent'](column);
        valueExporter = valueFormatter;
    }
    else {
        valueGetter = valueGetFactories['any'](column);
        valueFormatter = valueDisplayFactories[columnType](column);
        valueExporter = valueExportFactories[columnType](column);
    }
    // let tabulatorColumnDefinition = tabulatorColumnDefinitionFactories[columnType](
    // 	column,
    // 	valueFormatter
    // );
    return {
        column: column,
        type: columnType,
        value: valueGetter,
        display: valueFormatter,
        export: valueExporter,
        //tabulator: tabulatorColumnDefinition
    };
};
const getColumnType = (column, forceAuto) => {
    if (forceAuto === true || column?.probeOptions?.table?.render === 'auto') {
        if (column.probeType.toLowerCase().startsWith('datetime')) {
            return 'instant';
        }
        else if (column.probeType.toLowerCase().startsWith('duration')) {
            return 'duration';
        }
        else if (column.probeType === 'boolean') {
            return 'boolean';
        }
        else if (column.enumLabels) {
            return 'enum';
        }
        else {
            return 'any';
        }
    }
    else if (column?.probeOptions?.table?.render === 'mapDependent') {
        return 'dependent';
    }
    else {
        return 'any';
    }
};
const NO_CONTENT_LABEL = '&mdash;';
const valueGetFactories = {
    any: (column) => {
        return (datum) => lookupProperty(datum, column.field);
    },
    dependent: (column) => {
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            if (value == undefined) {
                return undefined;
            }
            else {
                if (column.probeOptions?.table?.mappers) {
                    let referencedPropertyDefinition = column.probeOptions.table.mappers[value];
                    return referencedPropertyDefinition.value(datum);
                }
                else {
                    return undefined;
                }
            }
        };
    }
};
const valueExportFactories = {
    instant: (column) => {
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value == undefined ? undefined : new Date(value).toISOString();
        };
    },
    duration: (column) => {
        let precision = column.probeOptions?.durationPrecision
            ? column.probeOptions.durationPrecision
            : DurationPrecision.minutes;
        let toDuration = (value) => {
            let duration = millisToDuration(value, precision);
            switch (precision) {
                case DurationPrecision.hours:
                    return duration.hours;
                case DurationPrecision.minutes:
                    return duration.hours * 60 + duration.minutes;
                case DurationPrecision.seconds:
                    return (duration.hours * 3600 +
                        duration.minutes * 60 +
                        duration.seconds);
                default:
                    return (duration.hours * 3600000 +
                        duration.minutes * 60000 +
                        duration.seconds * 1000 +
                        duration.milliseconds);
            }
        };
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value == undefined ? undefined : toDuration(value);
        };
    },
    boolean: (column) => {
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value;
        };
    },
    enum: (column) => {
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value == undefined
                ? undefined
                : column.enumLabels[value] != undefined
                    ? '' + column.enumLabels[value]
                    : '' + value;
        };
    },
    any: (column) => {
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value == undefined ? undefined : '' + value;
        };
    }
};
const valueDisplayFactories = {
    instant: (column) => {
        let defaultLabel = column.defaultContent ? column.defaultContent : NO_CONTENT_LABEL;
        let format = column.probeOptions?.dateFormat
            ? column.probeOptions.dateFormat
            : { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        let dateTimeFormatOptions = typeof format === 'object'
            ? format
            : format === 'L'
                ? { year: 'numeric', month: 'numeric', day: 'numeric' }
                : format === 'LT'
                    ? { hour: 'numeric', minute: 'numeric' }
                    : { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value == undefined
                ? defaultLabel
                : new Intl.DateTimeFormat(navigator.language, dateTimeFormatOptions).format(value);
        };
    },
    duration: (column) => {
        let defaultLabel = column.defaultContent ? column.defaultContent : NO_CONTENT_LABEL;
        let precision = column.probeOptions?.durationPrecision
            ? column.probeOptions.durationPrecision
            : DurationPrecision.minutes;
        const separators = getTemporalSeparators(navigator.language);
        let toDurationLabel = (value) => {
            let duration = durationToStrings(millisToDuration(value, precision));
            switch (precision) {
                case DurationPrecision.hours:
                    return `${duration.hours}`;
                case DurationPrecision.minutes:
                    return `${duration.hours}${separators.timeSeparator}${duration.minutes}`;
                case DurationPrecision.seconds:
                    return `${duration.hours}${separators.timeSeparator}${duration.minutes}${separators.timeSeparator}${duration.seconds}`;
                default:
                    return `${duration.hours}${separators.timeSeparator}${duration.minutes}${separators.timeSeparator}${duration.seconds}${separators.fractionalSeparator}${duration.millis}`;
            }
        };
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value == undefined ? defaultLabel : toDurationLabel(value);
        };
    },
    boolean: (column) => {
        let defaultLabel = column.defaultContent ? column.defaultContent : NO_CONTENT_LABEL;
        let trueLabel = column.probeOptions?.table?.trueLabel
            ? column.probeOptions.table.trueLabel
            : '<span class="icon-ok"></span>';
        let falseLabel = column.probeOptions?.table?.falseLabel
            ? column.probeOptions.table.falseLabel
            : '<span class="icon-cancel"></span>';
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value == undefined ? defaultLabel : value ? trueLabel : falseLabel;
        };
    },
    enum: (column) => {
        let defaultLabel = column.defaultContent ? column.defaultContent : NO_CONTENT_LABEL;
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value == undefined
                ? defaultLabel
                : column.enumLabels[value] != undefined
                    ? '' + column.enumLabels[value]
                    : '' + value;
        };
    },
    any: (column) => {
        let defaultLabel = column.defaultContent ? column.defaultContent : NO_CONTENT_LABEL;
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            return value == undefined ? defaultLabel : '' + value;
        };
    },
    dependent: (column) => {
        let defaultLabel = column.defaultContent ? column.defaultContent : NO_CONTENT_LABEL;
        return (datum) => {
            let value = lookupProperty(datum, column.field);
            if (value == undefined) {
                return defaultLabel;
            }
            else {
                if (column.probeOptions?.table?.mappers) {
                    let referencedPropertyDefinition = column.probeOptions.table.mappers[value];
                    return referencedPropertyDefinition.display(datum);
                }
                else {
                    return defaultLabel;
                }
            }
        };
    }
};
//coming from util/util.ts
const lookupProperty = (datum, property) => {
    if (datum && property && property.length > 0) {
        let fields = property.split('.');
        return fields.reduce((value, field) => {
            if (value !== undefined && field !== undefined && field.length > 0) {
                return value[field];
            }
            return undefined;
        }, datum);
    }
    else {
        return undefined;
    }
};
var DurationPrecision;
(function (DurationPrecision) {
    DurationPrecision[DurationPrecision["hours"] = 0] = "hours";
    DurationPrecision[DurationPrecision["minutes"] = 1] = "minutes";
    DurationPrecision[DurationPrecision["seconds"] = 2] = "seconds";
    DurationPrecision[DurationPrecision["millis"] = 3] = "millis";
})(DurationPrecision || (DurationPrecision = {}));
const millisToDuration = (millis, precision, returnZeros = true) => {
    millis = Math.round(millis);
    let hours = Math.floor(millis / 3600000);
    millis -= hours * 3600000;
    let minutes = Math.floor(millis / 60000);
    millis -= minutes * 60000;
    let seconds = Math.floor(millis / 1000);
    millis -= seconds * 1000;
    seconds +=
        precision !== undefined && precision < DurationPrecision.millis && millis >= 500 ? 1 : 0;
    minutes +=
        precision !== undefined && precision < DurationPrecision.seconds && seconds >= 30 ? 1 : 0;
    hours +=
        precision !== undefined && precision < DurationPrecision.minutes && minutes >= 30 ? 1 : 0;
    return {
        hours: hours,
        minutes: precision !== undefined && precision < DurationPrecision.minutes
            ? returnZeros
                ? 0
                : undefined
            : minutes,
        seconds: precision !== undefined && precision < DurationPrecision.seconds
            ? returnZeros
                ? 0
                : undefined
            : seconds,
        milliseconds: precision !== undefined && precision < DurationPrecision.millis
            ? returnZeros
                ? 0
                : undefined
            : millis
    };
};
const durationToStrings = (duration) => {
    return {
        hours: String(duration.hours),
        minutes: duration.minutes !== undefined
            ? (duration.minutes < 10 ? '0' : '') + String(duration.minutes)
            : undefined,
        seconds: duration.seconds !== undefined
            ? (duration.seconds < 10 ? '0' : '') + String(duration.seconds)
            : undefined,
        millis: duration.milliseconds !== undefined
            ? (duration.milliseconds < 10 ? '00' : duration.milliseconds < 100 ? '0' : '') +
                String(duration.milliseconds)
            : undefined
    };
};
